import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import './style.css';
import QuestionDetail from './components/QuestionDetail';
import GroupBtn from './components/groupBtn';
import BlockRight from './components/blockRight';
import ControlMobi from './components/controlMobi';
import callApi from '../../services/callApi'
import { bindActionCreators } from 'redux';
import _ from 'lodash'
import ResuiltExam from '../resuiltExam';
import ResultExamDetail from '../resultExamDetail';
import index from "material-table";

class ExamDetail extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            activePage: 1,
            questions: [],
            exam: {},
            answers: [],
            index_question_active: 0,
            result_exam:{
                total_answered: 0,
                spend_time: "00:00",
            },
            exam_id: this.props.match.params.exam_id,
        };
    }

    async componentDidMount(){
        const {exam_id} = this.state;
        const response = await callApi('v1/exam/'+exam_id, 'get');
        if(response.code != 200){
            alert('Không tìm thấy bài tập tự luyện');
            return null;
            window.location.reload();
        }
        let questions = [];
        response.fetchData.questions.map((item, index) => {
            if(item.type == 0 || item.type == 2) {
                questions.push(item);
            } else if(item.type == 1 || item.type == 3){
                item.content.sub_question.forEach(function (sub_q,index1) {
                    let newItem = _.cloneDeep(item);
                    newItem.content.sub_question = [sub_q];
                    newItem.content.sub_id = index1;
                    questions.push(newItem);
                });
            }
        })
        this.setState({
            exam: response.fetchData.exam,
            questions: questions,
        })
    }

    async componentWillReceiveProps(nexrProps){
        if(this.props.match.params.exam_id != nexrProps.match.params.exam_id){
            const{ exam_id} = nexrProps;
            const response =  await callApi('v1/exam/'+exam_id, 'get');
            if(response.code != 200){
                alert('Không tìm thấy bài tập tự luyện');
                return null;
                window.location.reload();
            }
            this.setState({
                exam: response.fetchData.exam,
                questions: response.fetchData.questions,
                exam_id: exam_id
            })
        }
    }

    handleSubmit = (spend_time) =>{
        const {result_exam} = _.cloneDeep(this.state);
        let second = spend_time % 60 < 10 ? '0'+spend_time % 60 : spend_time % 60;
        let minutes = (spend_time - (spend_time % 60))/60 < 10 ? '0'+(spend_time - (spend_time % 60))/60 : (spend_time - (spend_time % 60))/60;
        result_exam.spend_time = minutes + ':' + second;
        this.setState({ activePage: 2, result_exam: result_exam });
    }

    onChangePageViewAnswer = () =>{
        this.setState({ activePage: 3 });
    }

    handleAnswer = async(index_sub_q,option_answer,question_id) => {
        const {questions, result_exam} = _.cloneDeep(this.state);
        if(index_sub_q != null){   //co sub_question
            const questions_new = await questions.map(item => {
                if(item.gid == question_id && index_sub_q == item.content.sub_id){
                    item.content.answered = option_answer;
                }
                return item;
            });
            this.setState(prevState => ({
                questions: questions_new
            }));
        }else {
            const questions_new = await questions.map(item => {
                if(item.gid == question_id){
                    item.content.answered = option_answer;
                }
                return item;
            });
            this.setState(prevState => ({
                questions: questions_new
            }));
        }

        let total_answered = 0;
        await questions.map(item => {
            if(item.content.answered && item.content.answered > 0){
                total_answered ++;
            }
        });
        result_exam.total_answered = total_answered;
        this.setState(prevState => ({
            result_exam: result_exam
        }));
    }

    previousQuestion = () =>{
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
        });
        const {index_question_active} = this.state;
        this.setState({
            index_question_active: (index_question_active - 1 < 0) ? 0 : index_question_active - 1
        })
    }

    nextQuestion = () =>{
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
        });
        const {index_question_active, questions} = this.state;
        this.setState({
            index_question_active: (index_question_active + 1 == questions.length) ? questions.length : index_question_active + 1
        })
    }

    changeActiveQuestion = (index) =>{
        this.setState({
            index_question_active: index
        })
    }

    render() {
        const {questions, exam, activePage, index_question_active, result_exam,exam_id} = this.state;
        if(_.isEmpty(exam)){
            return null;
        }
        const total_question = questions.length;
        return (
            <div id="bodyContent">
                {activePage === 1 && <div className="container" id="page-do-exam">
                    <div className="left fl">
                        <div className="topTitle">
                            <a className="itemBreadcrumb">{exam.title}</a>
                        </div>
                        <ControlMobi time_to_do={exam.time_to_do} questions={questions} total_question={total_question} changeActiveQuestion={this.changeActiveQuestion}
                                     handleSubmit={this.handleSubmit} total_answered={result_exam.total_answered}/>
                        <div className="questionBody">
                            <div className="questionPageXDA">
                                <QuestionDetail
                                    activePage={activePage} index_question_active={index_question_active} questionDetail={questions[index_question_active]}
                                    handleAnswer={this.handleAnswer}
                                />
                            </div>
                            <GroupBtn time_to_do={exam.time_to_do} handleSubmit={this.handleSubmit} previousQuestion={this.previousQuestion} nextQuestion={this.nextQuestion} total_question={total_question} index_question_active={index_question_active} />
                        </div>
                    </div>
                    <div className="right fl">
                        <BlockRight time_to_do={exam.time_to_do} questions={questions} total_question={total_question} changeActiveQuestion={this.changeActiveQuestion}
                            handleSubmit={this.handleSubmit} total_answered={result_exam.total_answered} />
                    </div>
                    <div className="clear"></div>
                </div>}
                {activePage == 2 && <ResuiltExam exam_id={exam_id} spend_time={result_exam.spend_time} questions={questions} exam={exam} onChangePageViewAnswer={this.onChangePageViewAnswer} />}
                {activePage == 3 && <ResultExamDetail activePage={activePage} questions={questions} exam={exam}/>}
            </div>
        );
    }
}
export default ExamDetail;
